<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <!-- 过户 -->
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="tearDownModel" :rules="tearDownModelValidatorRules" slot="detail" :colon="false">
          <div class="">
              <a-divider class="aDividerBlue" orientation="left">{{ $t('表具信息') }}</a-divider>
              <detail-list :col="3">
                <detail-list-item :term="$t('表编号')">{{oldUserInfoNew.meterId}}</detail-list-item>
                <detail-list-item :term="$t('表类型')">{{oldUserInfoNew.meterTypeName}}</detail-list-item>
                <detail-list-item :term="$t('计费起始读数')">{{oldUserInfoNew.userMeterStartNum}}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('IMEI号')">{{oldUserInfoNew.mtImei}}</detail-list-item>
                <detail-list-item :term="$t('SIM卡号')">{{oldUserInfoNew.mtSim}}</detail-list-item>
                <detail-list-item :term="$t('表安装地址')">{{oldUserInfoNew.userMeterAddr}}</detail-list-item>
              </detail-list>
              <a-divider class="aDividerBlue" orientation="left">{{ $t('旧用户信息') }}</a-divider>
              <detail-list :col="3">
                <detail-list-item :term="$t('用户编号')">{{oldUserInfoNew.userId}}</detail-list-item>
                <detail-list-item :term="$t('用户姓名')">{{oldUserInfoNew.userName}}</detail-list-item>
                <detail-list-item :term="$t('手机号码')">{{oldUserInfoNew.userPhone}}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('身份证号')">{{oldUserInfoNew.userIdNumber}}</detail-list-item>
                <detail-list-item :term="$t('用户类型')">{{oldUserInfoNew.userTypeName}}</detail-list-item>
                <detail-list-item :term="$t('价格名称')">{{oldUserInfoNew.wtName}}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('用水状态')">{{oldUserInfoNew.userState==0?$t('未开始计费'):oldUserInfoNew.userState==1?$t('已开始计费'):''}}</detail-list-item>
                <detail-list-item :term="$t('营收编号')">{{oldUserInfoNew.userPayId}}</detail-list-item>
                <detail-list-item :term="$t('优惠信息')">{{'user_free_type'|filterDictTextByCache(oldUserInfoNew.userFreeinfo)}}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('是否允许缴费')">{{oldUserInfoNew.userPayState==0?$t('不允许'):oldUserInfoNew.userPayState==1?$t('允许'):''}}</detail-list-item>
                <detail-list-item :term="$t('用户地址')" style="width: 66.66%;">{{oldUserInfoNew.userAreaName?.slice(oldUserInfoNew.userAreaName.indexOf('-')+1,oldUserInfoNew.userAreaName.length)+'-'+oldUserInfoNew.userAddr}}</detail-list-item>
              </detail-list>
              <detail-list :col="1">
                <detail-list-item :term="$t('小区或村庄名')">{{oldUserInfoNew.userCommName}}</detail-list-item>
              </detail-list>
              <a-divider class="aDividerBlue" orientation="left">{{ $t('新用户信息') }}</a-divider>
              <detail-list :col="3">
                <!-- <detail-list-item term="用户编号">{{tearDownModel.meterUserTransfer.userId}}</detail-list-item> -->
                <!-- <detail-list-item term="价格名称">{{userPriceCode[tearDownModel.meterUserTransfer.userPriceCode]}}</detail-list-item> -->
                <!-- <detail-list-item term="用水类型">{{userHouseholdCodeList[tearDownModel.meterUserTransfer.userHouseholdCode]}}</detail-list-item> -->
                <detail-list-item :term="$t('用户编号')">{{oldUserInfoNew.userId}}</detail-list-item>
                <detail-list-item :term="$t('价格名称')">{{oldUserInfoNew.wtName}}</detail-list-item>
                <detail-list-item :term="$t('用水类型')">{{userHouseholdCodeList[oldUserInfoNew.userHouseholdCode]}}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <!-- <detail-list-item term="用户类型">{{userTypeList[tearDownModel.meterUserTransfer.userTypeCode]}}</detail-list-item> -->
                <!-- <detail-list-item term="优惠信息">{{tearDownModel.meterUserTransfer.userFreeinfo}}</detail-list-item> -->
                <detail-list-item :term="$t('用户类型')">{{oldUserInfoNew.userTypeName}}</detail-list-item>
                <detail-list-item :term="$t('身份类型')">{{(tearDownModel.meterUserTransfer||{}).userIdType==1?$t('自然人'):(tearDownModel.meterUserTransfer||{}).userIdType==0?$t('企业'):''}}</detail-list-item>
                <detail-list-item :term="$t('优惠信息')">{{'user_free_type'|filterDictTextByCache(oldUserInfoNew.userFreeinfo)}}</detail-list-item>
              </detail-list>
              <detail-list :col="3">
                <detail-list-item :term="$t('用户姓名')">{{(tearDownModel.meterUserTransfer||{}).userName}}</detail-list-item>
                <detail-list-item :term="$t('手机号码')">{{(tearDownModel.meterUserTransfer||{}).userPhone}}</detail-list-item>
                <detail-list-item :term="$t('身份证号')">{{(tearDownModel.meterUserTransfer||{}).userIdNumber}}</detail-list-item>
              </detail-list>
              <a-divider class="aDividerBlue" orientation="left">{{ $t('其他信息') }}</a-divider>
              <a-descriptions :col="1" >
                <a-descriptions-item :label="$t('申请原因')">{{ tearDownModel.applyDescription }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :col="1" >
                <a-descriptions-item :label="$t('电子签名')"></a-descriptions-item>
              </a-descriptions>
              <j-image-upload 
                class="avatar-uploader" 
                :text="$t('上传')" 
                :isMultiple="true" 
                v-model="tearDownModel.applySignature" 
                :disabled="true"
              />
              <!-- <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false">
                <img style="width: 180px; height: 80px;" :src="tearDownModel.applySignature"/>
                <div class="mask-sig" :class="{'mask-show': isShow}">
                  <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                  <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                </div>
              </div> -->
              <a-row :gutter="16" style="margin-top: 16px;">
                <a-col :span="16">
                  <a-descriptions :col="1" >
                    <a-descriptions-item :label="$t('身份证正反面')"></a-descriptions-item>
                  </a-descriptions>
                  <j-image-upload 
                  class="avatar-uploader" 
                  :text="$t('上传')" 
                  :isMultiple="true" 
                    v-model="fileList" 
                    :disabled="true"
                  />
                </a-col>
                
                <a-col :span="8">
                  <a-descriptions :col="1" >
                    <a-descriptions-item :label="$t('房产证')"></a-descriptions-item>
                  </a-descriptions>
                  <j-image-upload 
                  class="avatar-uploader" 
                  :text="$t('上传')" 
                  :isMultiple="true" 
                  v-model="tearDownModel.userTitleDeed" 
                  :disabled="true"
                  />
                </a-col>
              </a-row>
              
              <template v-if="!tearDownModel.selfFlag">
                <a-row :gutter="16" style="margin-top: 16px;">
                  <a-col :span="16">
                    <a-descriptions :col="1" >
                      <a-descriptions-item :label="$t('被委托人身份证（正反面）')"></a-descriptions-item>
                    </a-descriptions>
                    <j-image-upload 
                    class="avatar-uploader" 
                    :text="$t('上传')" 
                    :isMultiple="true" 
                    v-model="reportUserFileList" 
                    :disabled="true"
                    />
                  </a-col>
                  
                  <a-col :span="8">
                    <a-descriptions :col="1" >
                      <a-descriptions-item :label="$t('委托书')"></a-descriptions-item>
                    </a-descriptions>
                    <j-image-upload 
                    class="avatar-uploader" 
                    :text="$t('上传')" 
                    :isMultiple="true" 
                    v-model="tearDownModel.reportUserInformation" 
                    :disabled="true"
                    />
                  </a-col>
                </a-row>
              </template>
              <!-- 审批信息 -->
              <a-row :gutter="24" v-if="!notInput">
              <a-col :span="24">
                <a-form-model-item :label="$t('审批意见')" prop="isAgree">
                  <a-radio-group v-model="tearDownModel.isAgree">
                    <a-radio :value="1">{{ $t('通过') }}</a-radio>
                    <a-radio :value="0">{{ $t('驳回') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('审批描述')" prop="approvalDescription">
                  <a-textarea v-model="tearDownModel.approvalDescription" :placeholder="$t('请输入审批描述')" :rows="4" />
                </a-form-model-item>
              </a-col>
              </a-row>
          </div>
        </a-form-model>
        <j-modal :title="$t('预览')" :width="448" :visible="visibleSig" @cancel="handleSigCancel" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
          <div style="width: 400px;height: 400px;">
            <img :src="tearDownModel.applySignature" alt="" style="width: 100%;height: 100%;" />
          </div>
        </j-modal>
        
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import pick from 'lodash.pick'
  import {listSize } from '@/utils/util'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import PageLayout from '@/components/page/PageLayout'
  import {CardIdNumberPattern,PhoneNumberPattern} from '@/utils/regPattern'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    // mixins: [JeecgListMixin],
    name: 'TransferUser',
    components: {
      JImageUpload,
      DetailList,
      DetailListItem,
      PageLayout,
    },
    filters: {
      filterDictTextByCache
    },
    data() {
      return {
        title: '',
        optionType:"", // 操作类型 报停 复接
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        infoId: "", // 传入数据主键
        userHouseholdCodeList:{}, // 用户户型
        userPriceCode:{}, // 价格编码
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfoTransferRecord/doTransferTask",
          queryOldUserById: "/jeecg-charge/meter/meterUserinfo/list",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list", //用户户型列表接口
          userTypeList:"/jeecg-charge/meter/meterUserType/list",  //类别编码列表接口
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list", //价格编码列表接口
          updateState: "/jeecg-charge/meter/wechatUserApply/updateState",
          priceList: "jeecg-charge/meter/meterPriceinfo/list",
          queryUserById: "/jeecg-charge/meter/wechatUserApply/queryById",
        },
        tearDownModel: { // 报停对象
          userType: undefined, // 用户类型 户主1 非户主0
          meterUserTransfer: {}, // 新用户信息(过户),接口返回前为空对象,避免模板读取嵌套字段报错
        },
        installModel: { // 复接对象
          userType: undefined // 用户类型 户主1 非户主0
        },
        priceList: {},
        userTypeList: {},
        oldUserInfoNew: {},
        newUserInfoNew: {},
        isShow: false,
        fileList:'', // 本人身份证
        reportUserFileList:'', // 被委托人身份证
        visibleSig:false,
        notInput:false,
      }
    },
    computed: {
      tearDownModelValidatorRules() {
        return {
          isAgree: [{
            required: true,
            message: this.$t('请选择审批意见'),
            trigger: 'blur'
          }],
          approvalDescription: [{
            required: true,
            message: this.$t('请输入审批描述'),
            trigger: 'blur'
          }],
        };
      },
    },
    methods: {
      getuserPriceCode(){
        let params = {
          pageSize: 1000,
          userId: this.tearDownModel.userId
        }
        getAction(this.url.userPriceCode,params).then(res=>{ 
          if(res.success){
            res.result.records.map(item=>{ 
              this.$set(this.userPriceCode, item.id, item.wtName);
            })
          }
        })
      },
      getuserHouseholdCodeList(){
        let params = {
          pageSize: 1000,
        }
        getAction(this.url.userPriceCode,params).then(res=>{ 
          if(res.success){
            res.result.records.map(item=>{ 
              this.$set(this.userHouseholdCodeList, item.id, item.htName);
            })
          }
        })
      },
      viewSig(){
        this.visibleSig = true;
      },
      handleSigCancel(){
        this.visibleSig = false;
      },
      downloadSig(){
        this.downloadFile(this.tearDownModel.applySignature, this.$t('签名'))
      },
      downloadFile(url, name) {
        console.log('url==', url)
        var a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("download", name)
        a.setAttribute("target", "_blank")
        let clickEvent = document.createEvent("MouseEvents")
        clickEvent.initEvent("click", true, true)
        a.dispatchEvent(clickEvent)
      },
      init(row,type){
        this.visible = true;
        if(type == "approve"){
          this.optionType = type
          this.title = this.$t('过户审批');
          this.notInput = false;
          this.disableSubmit = false;
        }else{
          this.optionType = type
          this.title = this.$t('过户详情');
          this.notInput = true;
          this.disableSubmit = true;
        }
        this.infoId = row.id
        // this.model = JSON.parse(JSON.stringify(row));
        this.tearDownModel = { meterUserTransfer: {} };
        this.oldUserInfoNew = {};
        this.newUserInfoNew = {};
        this.installModel = {};
        this.tearDownInit();
        this.getuserPriceCode();
        this.getuserHouseholdCodeList();
      },
      // 报停 初始化
      tearDownInit(){
        // 获取报停数据
        getAction(this.url.queryUserById,{id:this.infoId}).then(res=>{
          if(res.success){
              this.tearDownModel = res.result;
              // 本人身份证
              let userIdCardFront = this.tearDownModel.userIdCardFront ? [this.tearDownModel.userIdCardFront] : [];
              let userIdCardOpposite = this.tearDownModel.userIdCardOpposite ? [this.tearDownModel.userIdCardOpposite] : [];

              // 被委托人身份证
              let reportUserIdCardFront = this.tearDownModel.reportUserIdCardFront ? [this.tearDownModel.reportUserIdCardFront] : [];
              let reportUserIdCardOpposite = this.tearDownModel.reportUserIdCardOpposite ? [this.tearDownModel.reportUserIdCardOpposite] : [];

              this.$nextTick(()=>{
                  this.$set(this,'fileList',[...userIdCardFront, ...userIdCardOpposite].join(','));
                  this.$set(this,'reportUserFileList',[...reportUserIdCardFront, ...reportUserIdCardOpposite].join(','));
              })
              // this.tearDownModel.valueJson = JSON.parse(this.tearDownModel.valueJson?this.tearDownModel.valueJson:null);
              if(this.tearDownModel.applyType == 4 || this.tearDownModel.applyType == 5) this.getpriceList();
              if(this.tearDownModel.applyType == 5) this.getuserTypeList();
              this.getOldUserInfoNew()
              // this.getNewUserInfoNew()
          }
        })
      },
      getOldUserInfoNew(){
        let params = {
					userId: this.tearDownModel.userId
				}
				getAction(this.url.queryOldUserById, params, 'GET').then(res => {
					if (res.success) {
						this.oldUserInfoNew =  res.result.records[0] || {}
					} 
				})
      },
      getNewUserInfoNew(){
        let params = {
					id: this.tearDownModel.userKeyId
				}
				getAction(this.url.queryById, params, 'GET').then(res => {
					if (res.success) {
						this.newUserInfoNew = Object.assign({},res.result);
					} 
				})
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        if(this.optionType == '详情'){
          this.close()
          return
        }
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let resultMessage = ''
            if(this.tearDownModel.isAgree){
              resultMessage = this.$t('审批通过')
            }else{
              resultMessage = this.$t('审批已驳回，工单存放在已办。')
            }
            let params = JSON.parse(JSON.stringify(this.tearDownModel));
            params.valueJson = JSON.stringify(this.tearDownModel.valueJson);
            postAction(this.url.updateState, params).then((res) => {
              if (res.success) {
                that.$message.success(resultMessage);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      getpriceList(){
        let that = this;
        getAction(this.url.priceList,{pageSize:1000}).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.$set(that.priceList, item.id, item.wtName)
            })
          }
        })
      },
      getuserTypeList(){
        this.userTypeList = {};
        getAction(this.url.userTypeList).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.$set(this.userTypeList, item.id, item.utName)
            })
          }
        })
      },
    }
  }
</script>
<style lang="less" scoped>
  .box-sig{
    width: 200px;
    height: 100px;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask-sig{
      visibility: hidden;
      position: absolute;
      width: 180px;
      height: 80px;
      top: 10px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      cursor: pointer;
      
      .icon-sig{
        color: rgba(255, 255, 255, 0.85);
        font-size: 16px;
      }
    }
    .mask-show{
      visibility: visible;
      transition: all 0.3s;
    }
  }
</style>